import React, { useEffect, useState } from "react";
import Reactportal from "../../Components/Reactportal/Reactportal";
import "../../Pages/UserRights/AddUserRights/AddUserRights.scss";
import AddUserRightsInput from "../UserRights/AddUserRights/AddUserRightsInput";
import { useMutation, useQuery } from "@apollo/client";
import { EditCN_Configuration, getCNConfigurationByID } from "../../../Utils/AllPagesQuriesAndMutations";
import { useNavigate } from "react-router-dom";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import { Loading } from "../../Components";
import { transformPageIdArray } from "../../custom_hooks/CheckPageAccess";


function getPageName(name) {
  let tableKey = "";
  switch (name) {
    case "Pickup_Memo":
      tableKey = "Pickup Assignment";
      break;
    case "Pickup_Updation":
      tableKey = "Pickup Updation";
      break;
    case "Inward_At_Warehouse":
      tableKey = "Warehouse Inward";
      break;
    case "Connection_Memo":
      tableKey = "Connection Planning";
      break;
    case "Connection_Memo_Update":
      tableKey = "Connection Status Update";
      break;
    case "Connection_Memo_Receive":
      tableKey = "Destination Inward";
      break;
    case "Delivery_Memo":
      tableKey = "Delivery Planning";
      break;
    case "CN_Delivery":
      tableKey = "Delivery Confirmation";
      break;
    default:
      tableKey = "";
  }
  return tableKey;
}

const LMSProcess = () => {
  const [toggle, setToggle] = useState(true);
  const navigate = useNavigate();
  const [pageData, setPageData] = useState({});
  let pagearr2 = transformPageIdArray();
  const { data, loading, refetch } = useQuery(getCNConfigurationByID, {
    variables: {
      pageIds: pagearr2,
    },
    fetchPolicy: "network-only",
  });
  const [EditingData, { loading: EditCNloading }] = useMutation(EditCN_Configuration);

  const Closeformfunction = () => {
    setToggle(false);
    navigate(-1);
  };

  useEffect(() => {
    if (pagearr2.length > 0) {
      refetch({ pageIds: pagearr2 });
    }
  }, [pagearr2]);

  useEffect(() => {
    if (data?.getCNConfigByCompanyID) {
      let obj = { ...data.getCNConfigByCompanyID };
      delete obj._id;
      delete obj.__typename;
      setPageData(obj);
    }
  }, [data])

  let DataArr = [
    {
      Column_name: "Page",
      name: "",
    },
    {
      Column_name: "Page Access",
      name: "Page_Access",
    },
    {
      Column_name: "CN Creation",
      name: "CN_Created",
    },
    {
      Column_name: "Pickup Assignment",
      name: "Pickup_Memo",
    },
    {
      Column_name: "Pickup Updation",
      name: "Pickup_Updation",
    },
    {
      Column_name: "Warehouse Inward",
      name: "Inward_At_Warehouse",
    },
    {
      Column_name: "Connection Planning",
      name: "Connection_Memo",
    },
    {
      Column_name: "Connection Status Update",
      name: "Connection_Memo_Update",
    },
    {
      Column_name: "Destination Inward",
      name: "Connection_Memo_Receive",
    },
    {
      Column_name: "Delivery Planning",
      name: "Delivery_Memo",
    },
  ];

  const handleData = (row, col, evt) => {
    let obj = { ...pageData };
    obj[row] = { ...obj[row] };
    obj[row][col] = evt.target.checked;
    setPageData(obj);
  };

  function removeTypename(obj) {
    // Create a new object to store the result
    const newObj = {};

    for (const key in obj) {
      if (obj[key] && typeof obj[key] === "object") {
        // Recursively apply the function to nested objects
        newObj[key] = removeTypename(obj[key]);
      } else {
        // Directly copy primitive values (strings, numbers, booleans)
        newObj[key] = obj[key];
      }
    }

    // Delete the __typename key if it exists in the current object
    if ("__typename" in newObj) {
      delete newObj.__typename;
    }

    return newObj;
  }

  let submit = (close) => {
    let obj = removeTypename(pageData);
    EditingData({ variables: { input: obj } })
      .then((res) => SuccessToast("CN Process Edited Successfully"))
      .catch((err) => ErrorToast(err?.massage));
  };

  return (
    <>
      <Reactportal
        open={toggle}
        onClose={() => Closeformfunction()}
        TypeOfPortal={"LMS Process"}
        TypeOfId={"Account Id :"}
      >
        {loading ? (
          <div className="loaderLMSPro">
            <Loading />
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr className="table-row">
                {DataArr &&
                  DataArr.length > 0 &&
                  DataArr.map((el) => (
                    <th className="table-header" style={{ padding: "0px 5px" }}>
                      <p>{el.Column_name}</p>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {Object.keys(pageData).map((key) => {
                return (
                  <tr className="table-row" key={key}>
                    {DataArr.map((col, i) => {
                      if (i === 0) {
                        return (
                          <td className="table-data" key={i}>
                            {getPageName(key)}
                          </td>
                        );
                      } else if (col.name in pageData[key]) {
                        const isDisabled =
                          (key === "Pickup_Memo" && col.name === "CN_Created") ||
                          (key === "Pickup_Updation" && col.name === "Pickup_Memo") ||
                          (key === "Connection_Memo_Update" && col.name === "Connection_Memo") ||
                          (key === "Connection_Memo_Receive" && col.name === "Connection_Memo");
                        return (
                          <td className="table-data" key={i} style={{ padding: "0px 5px" }}>
                            <AddUserRightsInput
                              disabled={isDisabled}
                              checked={pageData[key][col.name]}
                              name={col.name}
                              func={(evt) => {
                                handleData(key, col.name, evt);
                              }}
                            />
                          </td>
                        );
                      } else {
                        return <td className="table-data" key={i}></td>;
                      }
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          SaveAndClose={() => {
            Closeformfunction();
            submit("close");
          }}
          handleformclose={() => {
            Closeformfunction();
            setToggle(!toggle);
          }}
          submitType={"Submit"}
          UserRightsPortal={true}
          loadingState={EditCNloading || loading}
        />
      </Reactportal>
    </>
  );
};

export default LMSProcess;

{
  /* <div className="loader">
<Loading />
</div> */
}
{
  /* {ProcessArr &&
              ProcessArr.map((e) => (
                <>
                  <tr className="table-row">
                    <td className="table-data">
                      <p>{e.Name}</p>
                    </td>

                    {DataArr &&
                      DataArr.length > 0 &&
                      DataArr.map((el) => (
                        <td className="table-data">
                          {el.Fields.includes(e.Name) ? (
                            <AddUserRightsInput disabled={false} checked={false} name={""} func={() => {}} />
                          ) : (
                            ""
                          )}
                        </td>
                      ))}
                    {/* <td class="table-data" >{<AiFillDelete size={"1.5em"}/>}</td> */
}
//   </tr>
//   </>
// ))} */}
